import { AppState } from '../models/state/appState';

/**
 * Selected the command types state.
 * @param state
 */
export function selectCommandTypes(state: AppState) {
  return state.commandTypes;
}
